import { useState } from 'react';
import { Activity, Radio, Zap } from 'lucide-react';
import StatusMatrixGrid from './availability/StatusMatrixGrid';
import FleetReadinessTable from './availability/FleetReadinessTable';
import { computeStatusCounts, FLEET_READINESS } from './availability/mockAvailabilityData';

export default function AvailabilityEngine() {
  const [statusFilter, setStatusFilter] = useState(null);
  const counts = computeStatusCounts(FLEET_READINESS);
  const totalFleet = FLEET_READINESS.length;
  const dispatchReady = counts.available + counts.upcoming;

  return (
    <section aria-label="Truck availability engine" className="space-y-5">
      {/* Module header */}
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-logi-grid pb-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-teal-500/10 ring-1 ring-teal-500/30">
              <Zap className="h-4 w-4 text-teal-400" strokeWidth={1.75} />
            </div>
            <span className="text-xs font-semibold uppercase tracking-widest text-teal-400/80">
              OGTS LogiCore™ · Module 4 · Operations Center
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-bold uppercase text-emerald-700 ring-1 ring-emerald-500/30">
              <Radio className="h-2.5 w-2.5 animate-pulse" />
              Live
            </span>
          </div>
          <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
            Truck Availability Engine
          </h2>
          <p className="mt-1 text-sm text-logi-muted">
            Live fleet inventory · Instant dispatch readiness · Operational state matrix
          </p>
        </div>
        <div className="flex gap-3">
          <div className="rounded-xl border border-logi-grid bg-white px-3 py-2 text-center">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-logi-text0">
              Total Fleet
            </p>
            <p className="font-mono text-lg font-bold text-logi-text">{totalFleet}</p>
          </div>
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-center">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-logi-text0">
              Dispatch Ready
            </p>
            <p className="font-mono text-lg font-bold text-emerald-700">{dispatchReady}</p>
          </div>
        </div>
      </div>

      {/* Section 1 — Live Status Matrix */}
      <div>
        <div className="mb-3 flex items-center gap-2">
          <Activity className="h-4 w-4 text-logi-muted" strokeWidth={1.75} />
          <h3 className="text-sm font-bold text-logi-text">Live Availability Matrix Summary</h3>
          <span className="text-[10px] text-logi-text0">Click a block to filter ledger</span>
        </div>
        <StatusMatrixGrid
          activeFilter={statusFilter}
          onFilter={setStatusFilter}
        />
      </div>

      {/* Section 2 — Dispatcher query table */}
      <FleetReadinessTable statusFilter={statusFilter} />
    </section>
  );
}
